module.exports = __webpack_public_path__ + "static/media/9306177643_3b210d28e5_z.aea46b1d.jpg";